module.exports = __webpack_public_path__ + "static/media/italy.94ea31e7.svg";